import { VoucherTypeEnum } from '@zurich/api/party';
import { createStringEnumUtils, UnknownType } from '@zurich/common/utils';
export const partyRelationVoucherTypeUtils = createStringEnumUtils(VoucherTypeEnum, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'party:relation.voucher',
    excludeOptions: [VoucherTypeEnum.UNB],
});
